module.exports = __webpack_public_path__ + "img/item_bg.6c6b5fac.png";